// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gI","h5Button":"gI","button":"gJ","block":"gK","btnDefault":"gL","disable":"gM","btnPrimary":"gN"};